import { defaultDictionaryValueMissing } from '../repository';

export type LanguageKey = 'DA' | 'EN' | 'KL-GL';

export const getDefaultLanguageValue = (key: LanguageKey): string => {
	switch (key) {
		case 'DA':
			return 'Dansk';
		case 'EN':
			return 'Engelsk';
		case 'KL-GL':
			return 'Kalaallisut';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
